const constant = {
  // api: "https://api8.peascom.ma/api/",
  // url: "https://api8.peascom.ma/",

  // Local development
  // api: "http://localhost:8003/api/",
  // url: "http://localhost:8003/",

  // abdennaser taouritrt
  api: "https://api12.peascom.net/api/",
  url: "https://api12.peascom.net/",

  // Production (api12)
  // api: "https://api12.peascom.net/api/",
  // url: "https://api12.peascom.net/",

  authToken: "token-app-storekeeper",
  authUser: "user-app-storekeeper",
  userRoleKey: "user-role-storekeeper",
};
export default constant;
